module.exports = new __parcel__URL__("guard.65a69fa4.webp").toString();